module.exports = __webpack_public_path__ + "img/00015.3d23b45d.webp";